import { useEffect } from 'react';

export const useShortcut = (execute: any, shortcut: string | undefined) => {
	const handleKeyDown = (event: KeyboardEvent): void => {
		if (
			(event.metaKey || event.ctrlKey) &&
			event.code === `Key${shortcut?.toUpperCase()}`
		) {
			execute(true);
		}

		if (event.code === 'Escape') {
			execute(false);
		}
	};

	useEffect(() => {
		if (shortcut) {
			window.addEventListener('keydown', handleKeyDown);
			return () => window.removeEventListener('keydown', handleKeyDown);
		}
	}, [shortcut]);
};
